/**
 * SPDX-FileCopyrightText: 2024 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

// Keep in sync with Constants.php

/**
 * State of a form
 */
export enum FormState {
	FormActive = 0,
	FormClosed = 1,
	FormArchived = 2,
}
